module.exports = __webpack_public_path__ + "static/media/triviago.40307ece.jpg";